import { Check } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { CloseDialogIcon } from "assets/styles/icons";
import { useProgress } from "context/ProgressProvider";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SecurityService } from "services/SecurityService";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import { IsAnyCaveatsSchema } from "shared/helpers/Schema";
import Utils from "shared/helpers/Utils";
import { ProfileActions } from "state/profile/Action";

export const handleSaveProperty = (
  multi,
  data,
  loanId,
  callback,
  formik = null
) => {
  console.log(data);
  SecurityService.addSecurity(
    {
      isPropertyOwned: true, //always true if reach this
      noOfProperties: data.noOfProperties,
      properties: multi
        ? data.properties
        : [
            {
              propertyType: data.propertyType || null,
              propertyAddress: data.propertyAddress || null,
              estimatedPropertyAmount: data.estimatedPropertyAmount
                ? parseFloat(
                    String(data.estimatedPropertyAmount).replace(/,/g, "")
                  )
                : null,
              isAnyExistingLoan: data.isAnyExistingLoan || false,
              existingLoanSettlementOption:
                data.existingLoanSettlementOption || null,
              existingLoanAmount:
                parseFloat(String(data.existingLoanAmount).replace(/,/g, "")) ||
                0,
              isAnyCaveats: false, //always false if reach this
            },
          ],
    },
    loanId
  )
    .then((response: any) => {
      callback(response);
    })
    .catch((error: any) => {
      callback(false);
      Utils.handleErrorResponse(error);
    })
    .finally(() => {});
};

const LiabilitiesLegalTies = () => {
  const { handleCompleteAndNext, currentProfile } = useProgress();
  const [showRemoveCaveats, setShowRemoveCaveats] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [step, setStep] = useState(0);

  const handleSubmitForm = (value, formik = null) => {
    if (formik) {
      setSubmitLoading(true);
    }
    if (currentProfile.isAllowedToEdit) {
      if (!currentProfile.isAllowedToEdit?.liabilities) {
        handleCompleteAndNext();
        return;
      }
    }

    console.log(value);
    dispatch(ProfileActions.setSblProfile(value));
    if (value.isAnyCaveats) {
      setShowRemoveCaveats(true);
      setSubmitLoading(false);
      return;
    }
    handleSaveProperty(
      false,
      currentProfile,
      currentProfile.loadId,
      (res) => {
        if (res) handleCompleteAndNext();
      },
      formik
    );
  };

  const handleCloseRemoveCaveats = () => {
    setShowRemoveCaveats(false);
  };

  useEffect(() => {}, [step]);

  return (
    <>
      {currentProfile.properties && currentProfile.properties.length > 1 && (
        <>
          <Typography variant="h2">Security</Typography>
          <Typography variant="h3" mt={3}>
            Are there any caveats on the properties?
          </Typography>
          <Box mt={2}>
            {currentProfile.properties.map((data, index) => {
              return (
                <Box mt={3}>
                  <Typography>
                    Property {index + 1}{" "}
                    {`(${index + 1}/${currentProfile.properties.length})`}
                  </Typography>
                  <Box
                    sx={{
                      width: "485px",
                      borderRadius: "8px",
                      border: "1px solid #E5E5E5",
                      padding: "12px 16px",
                      display: "flex",
                      gap: "12px",
                    }}
                    mt={2}
                  >
                    <Avatar
                      alt={data.propertyAddress}
                      src="/images/avatar.png"
                    />
                    <Box sx={{ width: "70%" }}>
                      <Typography
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {data.propertyAddress}
                      </Typography>
                      <Typography fontWeight={200}>
                        {data.propertyType}
                      </Typography>
                    </Box>
                    <Typography color="#7DDB25">No Caveats</Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Box mt={4} sx={{ display: "flex", gap: "12px" }}>
            <AppPrimaryButton
              title="Continue"
              isLoading={false}
              onClick={() => handleCompleteAndNext()}
            />
          </Box>
        </>
      )}
      <Dialog open={showRemoveCaveats} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Remove caveats</Typography>
            <IconButton onClick={() => handleCloseRemoveCaveats()}>
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h3" fontWeight={400} mb={3}>
            For you to proceed with the application, you’ll need to remove the
            caveat/caveats from the property.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ gap: "12px" }}>
          <AppSecondaryButton
            title="Cancel"
            className="btn-small ezifin-default-outlined-button"
            onClick={() => handleCloseRemoveCaveats()}
            fullWidth
          />
          <AppPrimaryButton
            title="Okay, I understand"
            className="btn-small"
            onClick={() => {
              // dispatch(
              //   ProfileActions.setSblProfile({
              //     isAnyCaveats: false,
              //   })
              // ); force user to No
              handleCloseRemoveCaveats();
            }}
            fullWidth
          />
        </DialogActions>
      </Dialog>

      {Array.isArray(currentProfile.properties) &&
        (currentProfile.properties.length === 0 ||
          currentProfile.properties.length === 1) &&
        step === 0 && (
          <Box>
            <Formik
              enableReinitialize
              validationSchema={IsAnyCaveatsSchema}
              validateOnMount
              onSubmit={(value, formik) => {
                handleSubmitForm(value, formik);
              }}
              initialValues={{
                isAnyCaveats: currentProfile.isAnyCaveats,
              }}
            >
              {({
                values,
                setFieldValue,
                handleSubmit,
                errors,
                isSubmitting,
              }) => (
                <form autoComplete="off">
                  <Typography variant="h2">Security</Typography>
                  <Typography variant="h3" mt={3}>
                    Are there any caveats on the property?
                  </Typography>
                  <Box mt={2}>
                    <Box mt={2} sx={{ display: "flex", gap: "12px" }}>
                      {["Yes", "No"].map((option) => (
                        <Chip
                          key={option}
                          label={option}
                          clickable
                          variant="outlined"
                          color={
                            values.isAnyCaveats === (option === "Yes")
                              ? "primary"
                              : "default"
                          }
                          icon={
                            values.isAnyCaveats === (option === "Yes") ? (
                              <Check fontSize="small" />
                            ) : (
                              <></>
                            )
                          }
                          onClick={() =>
                            setFieldValue("isAnyCaveats", option === "Yes")
                          }
                        />
                      ))}
                    </Box>
                  </Box>

                  <Box mt={4} sx={{ display: "flex", gap: "12px" }}>
                    <AppPrimaryButton
                      title="Continue"
                      isLoading={submitLoading}
                      loadingText="Please wait.."
                      onClick={handleSubmit}
                      disabled={Object.keys(errors).length > 0 || submitLoading}
                    />
                  </Box>
                </form>
              )}
            </Formik>
          </Box>
        )}
    </>
  );
};

export default LiabilitiesLegalTies;
